import { render, staticRenderFns } from "./RateTable.vue?vue&type=template&id=0d59de9c&"
import script from "./RateTable.vue?vue&type=script&lang=ts&"
export * from "./RateTable.vue?vue&type=script&lang=ts&"
import style0 from "./RateTable.vue?vue&type=style&index=0&id=0d59de9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports